"use strict";
/* tslint:disable */
var TRegularSelection = (function () {
    "use strict";
    var api = {};
    // Template logic splitter
    api.buildView = function (mode, context) {
        return TRegularSelections.buildRegular(mode, this, context || {});
    };
    api.buildPick = function (mode, context) {
        return TRegularSelections.buildRegularPick(mode, this, context || {});
    };
    // Template logic splitter
    api.buildDescription = function (mode, context) {
        return TRegularSelections.buildRegularDescription(mode, this, context || {});
    };
    return api;
}());
/*exported TQASelection */ /*globals TQASelections */
var TQASelection = (function () {
    "use strict";
    var api = {};
    // Template logic splitter
    api.buildView = function (mode, context) {
        return TQASelections.buildQA(mode, this, context || {});
    };
    api.buildPick = function (mode, context) {
        return TQASelections.buildQAPick(mode, this, context || {});
    };
    // Template logic splitter
    api.buildDescription = function (mode, context) {
        return TQASelections.buildQADescription(mode, this, context || {});
    };
    return api;
}());
/*exported TMultiLineItem */ /*globals TMultiLineSelections */
var TMultiLineItem = (function () {
    "use strict";
    var api = {};
    // Template logic splitter
    api.buildView = function (mode, context) {
        return TMultiLineSelections.buildMultiLine(mode, this, context || {});
    };
    /*jshint maxparams:4*/
    api.buildPick = function (mode, context, selections) {
        return TMultiLineSelections.buildMultiPick(mode, this, context || {}, selections);
    };
    // Template logic splitter
    api.buildDescription = function (mode, context, selections) {
        return TMultiLineSelections.buildMultiDescription(mode, this, context || {}, selections);
    };
    /*jshint maxparams:3*/
    return api;
}());
window.TRegularSelection = TRegularSelection;
window.TQASelection = TQASelection;
window.TMultiLineItem = TMultiLineItem;
//# sourceMappingURL=TSelections.js.map